import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { InputCaption } from './Caption';

export interface StandaloneInputCaption extends StandaloneComponentProps<typeof InputCaption> {}

export const StandaloneInputCaption: StandaloneComponent<StandaloneInputCaption> = (props) => (
  <InputCaption {...props} />
);
